import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./OrderSuccess.css";

const OrderSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const order = location.state?.orderDetails;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!order) {
    return <p className="text-center mt-5">Invalid order</p>;
  }

  return (
    <div className="order-success-wrapper">
      <div className="order-success-card order-success-animate">
        <h2 className="order-success-title">
          Order Placed Successfully ✅
        </h2>

        <p className="order-success-sub">
          Thank you for shopping with us 🎉
        </p>

        {/* PRODUCT DETAILS */}
        <div className="order-success-product-box">
          <img
            src={order.productImage}
            alt={order.productName}
            className="order-success-product-img"
          />

          <div className="order-success-product-info">
            <h4 className="order-success-product-name">
              {order.productName}
            </h4>

            <p className="order-success-product-qty">
              Quantity: <strong>{order.quantity}</strong>
            </p>

            <p className="order-success-product-price">
              ₹{order.total}
            </p>
          </div>
        </div>

        {/* ADDRESS */}
        <div className="order-success-info">
          <h4>📍 Delivery Address</h4>
          <p>{order.address}</p>
        </div>

        {/* PAYMENT */}
        <div className="order-success-info">
          <h4>💳 Payment Method</h4>
          <p>{order.paymentMethod}</p>
        </div>

        <button
          className="order-success-btn"
          onClick={() => navigate("/orders")}
        >
          View My Orders
        </button>
      </div>
    </div>
  );
};

export default OrderSuccess;
